// /** @module maps/google */
import {LeafletMap} from "./map_leaflet";
import {MAP_TYPE_EDIT_GZ, MAP_TYPE_EDIT_POI} from "./map_base";

/**
 * @alias Ptx.maps.OSMEdit
 */
export const LeafletMapEdit = LeafletMap.extend(
		/** @lends module:maps/leaflet */
		{
			editClusterOpts: {
				'general': {},
				'vehicle': {},
				'tp': {}
			},
			drawnItems: null, //all items drawn on map
			buffer: null,//buffered shape of gz
			editTool: null, //currently used edit tool
			editToolName: 'POLYGON', //currently used edit tool name, by default polygon
			editToolList: {}, //available edittools


			constructor: function (mapContainer, opts, mapSettings) {
				this.name = "LEAF_E";
				this.clusterOpts[MAP_TYPE_EDIT_GZ] = this.editClusterOpts;
				this.clusterOpts[MAP_TYPE_EDIT_POI] = this.editClusterOpts;
				this.base(mapContainer, opts, mapSettings);
			},

			isInitializing: false,
			/** Init map drawing */
			internalMapInit: function (self) {
				var map = self.map;
				self.drawnItems = new L.FeatureGroup();
				map.addLayer(self.drawnItems);
				self.isInitializing = true;
			},

			/** @see maps/base#findMapCreatorFunction_ */
			findMapCreatorFunction_: function () {
				var mt = this.opts.mapType;
				if (mt === MAP_TYPE_EDIT_GZ || mt === MAP_TYPE_EDIT_POI) {
					this.prepareEditGeozonePOIMap(mt === MAP_TYPE_EDIT_POI);
				} else {
					return this.base();
				}

			},
			/** @see maps/google#gjDataShow
			 *  Redefine behaviour, so we load geojson data as editable, when on editable map
			 * */
			gjDataShow: function (geoJsonData, afterLoadCallback) {
				var mt = this.opts.mapType;
				if (mt === MAP_TYPE_EDIT_GZ || mt === MAP_TYPE_EDIT_POI) {
					this.removeEditShapes();
					var feature = this.getFeature_(geoJsonData);
					this.geoJson = feature;

					var type = feature.properties.gzType;
					var radius = feature.properties.radius;
//					//geometries, include points and multipolygon
					var gCollection = feature.geometry.geometries;
					var overlay;
					var eType;
					if (type == "POLYGON") {
						overlay = this.editCreators.createPolygonFromPoints(this, gCollection);
						eType = 'polygon'
					} else if (type == "POINT") {
						overlay = this.editCreators.createCircle(this, gCollection, radius);
						eType = 'circle'
					} else if (type == "POLYLINE") {
						overlay = this.editCreators.createPolyline(this, gCollection);
						eType = 'polyline'
					}

					this.addMapOverlay(overlay, eType);
					this.gjDataShowBounds();

					if (typeof afterLoadCallback == 'function') {
						afterLoadCallback();
					}
				} else {
					return this.base();
				}


			},
			/**
			 * Helper to create feature from geojson, even plain geometry
			 * @param gj geojson
			 * @return GeoJSON Feature for map
			 */
			getFeature_: function (gj) {
				function getType(t) {
					if (t == "LineString") return "POLYLINE";
					return t.toUpperCase();
				}

				if (gj.type && gj.type == 'Feature') return gj;
				var geomType = getType(gj.type);

				var f = {
					type: 'Feature',
					properties: {
						gzType: geomType,
						radius: 0
					},
					geometry: {
						type: 'GeometryCollection',
						geometries: []
					}
				};
				var cs = gj.coordinates;
				var gs = f.geometry.geometries;
				for (var i = 0; i < cs.length; i++) {

					gs.push({type: 'Point', coordinates: cs[i]});
				}
				f.geometry.geometries.push(gj);
				return f;
			},

			/**
			 * Remove existing edit shapes from the map
			 */
			removeEditShapes: function () {
				this.drawnItems.clearLayers();
			},
			/**
			 * Check if something is drawn on the map
			 */
			hasSomeOverlays: function () {
				return (this.drawnItems.getLayers() && this.drawnItems.getLayers().length > 0);
			},
			/**
			 * Return drawing on map
			 * @return layer or null if nothing is there
			 */
			getDrawnItem: function () {
				var self = this;
				if (self.hasSomeOverlays()) {
					return self.drawnItems.getLayers()[0];
				}
				return null;
			},

			editCreators: {
				/**
				 * Create polygon from geometry collection
				 * @param gCollection - array of geomtries, uses Points only
				 */
				createPolygonFromPoints: function (self, gCollection) {
					var polygon = [];
					for (var i in gCollection) { //go through geometrycollection and create polygon from points
						var geom = gCollection[i];
						if (geom.type == "Point") {
							var coords = geom.coordinates;
							var ll = new L.LatLng(coords[1], coords[0]);
							polygon.push(ll);
							self.geoBounds.extend(ll);
						}
					}
					return new L.Polygon(polygon);
				},
				/**
				 * Create polygon from Polygon geojson
				 */
				createPolygon: function (self, coords, opts) {
					var polygon = [];
					for (var i in coords) {
						var ll = new L.LatLng(coords[i][1], coords[i][0]);
						polygon.push(ll);
						//self.geoBounds.extend(ll);
					}
					var p = new L.Polygon(polygon);


					if (typeof opts != 'undefined') {
						p.setStyle(opts);
					}
					return p;
				},

				/**
				 * TODO complete, update this.buffer to be able to contain more polygons
				 */
				createMultiPolygon: function (self, coords, opts) {
					for (var i in coords) {
						self.editCreators.createPolygon(self, coords[i][0], opts);
					}
				},

				/**
				 * Create circle from first point in gCollection and radius
				 */
				createCircle: function (self, gCollection, radius) {
					var center = null;
					for (var i in gCollection) { //go through geometrycollection and create polygon from points
						var geom = gCollection[i];
						if (geom.type == "Point") {
							var coords = geom.coordinates;
							var center = new L.LatLng(coords[1], coords[0]);
							break;
						}
					}
					if (center != null) {

						var c = new L.Circle(center, radius).addTo(self.map);
						self.geoBounds = c.getBounds();
						return c;
					}
					console.log('Unable to create circle')
				},

				createPolyline: function (self, gCollection) {
					var polygon = [];
					for (var i in gCollection) { //go through geometrycollection and create polygon from points
						var geom = gCollection[i];
						if (geom.type == "Point") {
							var coords = geom.coordinates;
							var ll = new L.LatLng(coords[1], coords[0]);
							polygon.push(ll);
							self.geoBounds.extend(ll);
						}
					}
					return new L.Polyline(polygon);
				}

			},
			/**
			 * Add  map overlay that was drawn
			 * @param overlay - layer that was created
			 * @param type - type what was creted
			 */
			addMapOverlay: function (overlay, type) {
				if (overlay) {
					var self = this;

					function addShape(self, overlay) {
						function ev(info) {
							self.shapeChanged();
						}

						self.removeEditShapes();
						self.drawnItems.addLayer(overlay);

						if (type === 'polygon') {
							overlay.options.editing || (overlay.options.editing = {});
							overlay.editing.enable();
							overlay.dragging.enable();

							overlay.on('dragstart', function () {
								if (overlay.editing && typeof overlay.editing.disable === 'function') {
									overlay.editing.disable();
								}
							});
							overlay.on('dragend', function () {
								if (overlay.editing && typeof overlay.editing.enable === 'function') {
									overlay.editing.enable();
								}
								if (overlay.editing && typeof overlay.editing.updateMarkers === 'function') {
									overlay.editing.updateMarkers();
								}
								self.shapeChanged();
							});
						}


						if (type === 'circle') {
							var info = {
								radius: overlay.getRadius(),
								lat: overlay.getLatLng().lat,
								lon: overlay.getLatLng().lng,
								fromMap: true
							};
							self.propagateInfo(info);

							overlay.on('edit', function () {
								var info = {
									radius: overlay.getRadius(),
									lat: overlay.getLatLng().lat,
									lon: overlay.getLatLng().lng,
									fromMap: true
								};
								self.propagateInfo(info);
								ev();
							});

							overlay.on('dragend', function () {
								self.shapeChanged();
							});
						} else {
							overlay.on('edit', ev);
						}

						ev();
						self.setMapMode('edit');
					}

					if (this.hasSomeOverlays() && !self.isInitializing) {
						self.removeEditShapes();
					}

					addShape(self, overlay);
					self.resetInitialization();
				}
			},

			resetInitialization: function () {
				this.isInitializing = false;
			},

			/**
			 * Push info into HTML page
			 */
			propagateInfo: function (obj) {
				function r_num(num, dec) {
					return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
				}

				$(this.opts.radiusInput).val(Math.round(Number(obj.radius)));

				if (obj.fromMap == true) {
					if (obj.lat && obj.lon) {
						var lat = r_num(Number(obj.lat), 6)
						var lon = r_num(Number(obj.lon), 6)

						$(this.opts.latInput).val(lat);
						$(this.opts.lonInput).val(lon);
					}
				}

			},

			/**
			 * Refresh map and buffer drawn items
			 */
			shapeChanged: function () {
				var rad = $(this.opts.radiusInput);
				var radius = rad.val();
				var gjOut = $(this.opts.geoJsonOutput);
				var gj = this.dumpGeoJSON();
				if (!this.isGeoJSONValid(gj)) return;

				gjOut.val(JSON.stringify(gj, null, ''));

				this.removeRealShape();

				if (radius != '') {
					if (radius != '0') {
						this.drawRealShape(gj, radius);
					} else {
						this.removeRealShape();
					}
				} else {
					rad.val('0');
					this.removeRealShape();
				}
			},

			/**
			 * Hide real geozone shape, buffered from server
			 */
			removeRealShape: function () {
				if (this.buffer) { //remove previous shape
					this.map.removeLayer(this.buffer);
					this.buffer = null;
				}
			},

			/**
			 * Draw buffered shape of given items
			 * @param geoJSON - data
			 * @param radius - meters to expand
			 */
			drawRealShape: function (geoJSON, radius) {
				if (geoJSON.type != 'Point') { // no need to buffer circle
					var gjStr = JSON.stringify(geoJSON, null, '');
					var self = this;

					this.removeRealShape();

					Ptx.fn.openPtx('/settings/geozones/geozones/buffer.json', "POST", {
						polyJson: gjStr,
						radius: radius
					}, function (data, svr) {
						var gj = JSON.parse(data);

						var ovl = self.editCreators.createPolygon(self, gj.coordinates[0][0], {
							strokeColor: 'red',
							fillOpacity: 0.15,
							fillColor: 'red'
						});

						ovl.addTo(self.map);
						ovl.bringToBack();
						self.buffer = ovl;
					});
				}
			},
			/**
			 * Return GeoJSON geometry representation of items drawn on map
			 * @return geoJson object, not string!! use JSON.stringify(geoJSON, null, '') to get string
			 */
			dumpGeoJSON: function (data) {
				var type = '';
				var coordinates = [];
				var item = this.getDrawnItem();
				if (typeof data != 'undefined') {
					item = data;
				}
				if (item != null) {
					var g = item.toGeoJSON().geometry;
					type = g.type;
					if (type == 'Polygon') { //it is multipolygon, but we can draw only one, so this simplifies our lifes
						coordinates = g.coordinates[0];
					} else if (type == 'LineString') {
						coordinates = g.coordinates;
					} else if (type == 'Point') { // TODO Multi?
						coordinates = [g.coordinates];
					}
				}

				return {'type': type, 'coordinates': coordinates};
			},

			/**
			 * Init for edit shapes
			 */
			prepareEditGeozonePOIMap: function (editPOI) {
				var self = this;
				var map = self.map;

				this.editToolList = {
					'POINT': new L.Draw.Circle(map),
					'POLYLINE': new L.Draw.Polyline(map),
					'POLYGON': new L.Draw.Polygon(map)
				};

				if (editPOI) {
					this.editToolList = {
						'POINT': new L.Draw.Circle(map)
					}
				}
				map.on('draw:created', function (e) {
					var l = e.layer;
					var t = e.layerType;
					self.addMapOverlay(l, t);
				})

			},


			/**
			 * Change edit tool of map
			 * @param type - string POINT, POLYGON, POLYLINE , or null to disable current edit tool
			 */
			setEditTool: function (type) {
				var mode = this.editToolList[type];
				if (this.editTool) {
					this.editTool.disable();
				}
				if (typeof mode != 'undefined' && mode != null) {
					this.editTool = mode;
					this.editToolName = type;
					this.editTool.enable();
				}
			},
			/**
			 * Change map between edit and draw mode of shapes
			 * @param mode - draw or edit
			 */
			setMapMode: function (mode) {
				var self = this;
				var item = self.getDrawnItem();
				if (mode == 'edit') {
					self.setEditTool(null); //disable current edit tool
					self.setEditable(item, true);
				} else { //draw
					self.setEditable(item, false);
					self.setEditTool(self.editToolName); //not nice
				}
			},

			/**
			 * Set POI on map
			 * @param lat
			 * @param lon
			 * @param radius in meters
			 * @param callback after item is visible
			 * @return true if item was shown
			 */
			showPOI: function (lat, lon, radius, callback) {
				this.removeEditShapes();
				if (lat && lat != '' && lon && lon != '' && radius && radius != '' && (Number(radius) > 0)) {
					var mm = this.map;

					var circle = new L.Circle({lat: Number(lat), lng: Number(lon)}, Number(radius));
					circle.addTo(mm);
					this.setEditable(circle, true);

					this.addMapOverlay(circle, 'circle');
					if (callback) callback();
					return true;
				} else {
					this.setEditTool('POINT');
					this.setMapMode('draw');
				}

				return false;
			},

			/**
			 * Update point from controls given as opt when constructed, and zoom to it
			 * works only on cicle gz, or POI, does nothing for any other type
			 */
			updatePoint: function () {
				function r_num(num, dec) {
					return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
				}

				var circle = this.getDrawnItem();
				if (circle != null) {
					var sRad = $(this.opts.radiusInput).val();
					if (sRad != '') {
						circle.setRadius(Number(sRad));
					}
					var sLat = $(this.opts.latInput).val();
					var sLon = $(this.opts.lonInput).val();
					if (sLat != '' && sLon != '') {
						circle.setLatLng({lat: r_num(Number(sLat), 6), lng: r_num(Number(sLon), 6)});
					}

					this.map.fitBounds(circle.getBounds());
				}
			},
			/**
			 * Mark item overlay as editable or not
			 */
			setEditable: function (item, editable) {
				if (item) {
					if (editable) {
						item.options.editing || (item.options.editing = {}); //BUG in leaflet draw - https://github.com/Leaflet/Leaflet.draw/issues/364#issuecomment-74184767
						item.editing.enable();
					} else {
						item.editing.disable();
					}
				}
			}

		});

